module.exports = __webpack_public_path__ + "img/en.7e3c94e6.png";